<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="policieslist" label="策略模板列表"></TabPane>
            <TabPane name="policiesadd" label="新建策略模板"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'policylayout',
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      if (this.$route.name === 'policies') this.changeRouter('policieslist')
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
